
export default {
  state: {
    countriesCollection: [],
    carriersCollection: [],
    collectionOnDelivery: []
  },
  getters: {
    getCountriesCollection: (state) => state.countriesCollection,
    getCarriersCollection: state => state.carriersCollection,
    getCollectionOnDelivery: state => state.collectionOnDelivery
  },
  mutations: {
    setCountriesCollection(state, val) {
      state.countriesCollection = {
        rows: val.rows.map(el => ({...el, text: el.name, _id: el.id}))
      }
    },
    setCarriersCollection(state, val) {
      state.carriersCollection = {
        rows: val.rows.map(el => ({...el, text: el.name, _id: el.id}))
      }
    },
    setCollectionOnDelivery(state, val) {
      state.collectionOnDelivery = {
        rows: val.rows.map(item => {
          return {
            carrier_name: item.carrier_name,
            min_val: item.min_val_formatted || '-',
            max_val: item.max_val_formatted || '-',
            percentage_cash: item.cash['enviame'].commission_percentage_formatted || '-',
            cash: item.cash['enviame'].min_payment_formatted || '-',
            percentage_instant_payment: item.instant_payment['enviame'].commission_percentage_formatted || '-',
            instant_payment: item.instant_payment['enviame'].min_payment_formatted || '-',
            percentage_credit_card: item.credit_card['enviame'].commission_percentage_formatted || '-',
            credit_card: item.credit_card['enviame'].min_payment_formatted || '-',
            delivery_creation_info: item.delivery_creation_info || '-',
            collection_cycle: item.collection_cycle || '-',
            deposit_in_account: item.deposit_in_account || '-',
            coverage_population: item.coverage_population || '-',
            observations: item.observations || '-',
            limit_services: item.limit_services || '-'
          }
        })
      }
    }
  }
}
